var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "max-w-7xl mx-auto my-5" }, [
      _c("div", { staticClass: "px-1 md:px-20" }, [
        _c("div", { staticClass: "mt-8  pb-16 sm:mt-12 sm:pb-20 lg:pb-28" }, [
          _c("div", { staticClass: "relative" }, [
            _c("div", { staticClass: "absolute inset-0 h-1/2 bg-gray-100" }),
            _c(
              "div",
              {
                staticClass:
                  "relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex"
                  },
                  [
                    _c("div", { staticClass: "bg-white px-6 py-8 lg:p-12" }, [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-2xl leading-8 font-extrabold text-gray-900 sm:text-3xl sm:leading-9"
                        },
                        [_vm._v(" Team Inbox ")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "mt-6 text-base leading-6 text-gray-500"
                        },
                        [
                          _vm._v(
                            " Engage with your customers on their favorite messaging app and sell more as a team. "
                          )
                        ]
                      ),
                      _c("div", { staticClass: "mt-8" }, [
                        _vm._m(0),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "mt-8 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-5"
                          },
                          [
                            _c(
                              "li",
                              { staticClass: "flex items-start lg:col-span-1" },
                              [
                                _c("div", { staticClass: "flex-shrink-0" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "h-5 w-5 text-green-400",
                                      attrs: {
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          d:
                                            "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                          "clip-rule": "evenodd"
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ml-3 text-sm leading-5 text-gray-700"
                                  },
                                  [
                                    _vm._v(
                                      " 1000 Session Messages included in the plan "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "li",
                              {
                                staticClass:
                                  "mt-5 flex items-start lg:col-span-1 lg:mt-0"
                              },
                              [
                                _c("div", { staticClass: "flex-shrink-0" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "h-5 w-5 text-green-400",
                                      attrs: {
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          d:
                                            "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                          "clip-rule": "evenodd"
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ml-3 text-sm leading-5 text-gray-700"
                                  },
                                  [_vm._v(" Free Whatsapp API approval ")]
                                )
                              ]
                            ),
                            _c(
                              "li",
                              {
                                staticClass:
                                  "mt-5 flex items-start lg:col-span-1 lg:mt-0"
                              },
                              [
                                _c("div", { staticClass: "flex-shrink-0" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "h-5 w-5 text-green-400",
                                      attrs: {
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          d:
                                            "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                          "clip-rule": "evenodd"
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ml-3 text-sm leading-5 text-gray-700"
                                  },
                                  [
                                    _vm._v(
                                      " Custom automated message templates "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "li",
                              {
                                staticClass:
                                  "mt-5 flex items-start lg:col-span-1 lg:mt-0"
                              },
                              [
                                _c("div", { staticClass: "flex-shrink-0" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "h-5 w-5 text-green-400",
                                      attrs: {
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          d:
                                            "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                          "clip-rule": "evenodd"
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ml-3 text-sm leading-5 text-gray-700"
                                  },
                                  [_vm._v(" Priority customer support ")]
                                )
                              ]
                            ),
                            _c(
                              "li",
                              {
                                staticClass:
                                  "mt-5 flex items-start lg:col-span-1 lg:mt-0"
                              },
                              [
                                _c("div", { staticClass: "flex-shrink-0" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "h-5 w-5 text-green-400",
                                      attrs: {
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          d:
                                            "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                          "clip-rule": "evenodd"
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ml-3 text-sm leading-5 text-gray-700"
                                  },
                                  [_vm._v(" Early access to our new features ")]
                                )
                              ]
                            ),
                            _c(
                              "li",
                              {
                                staticClass:
                                  "mt-5 flex items-start lg:col-span-1 lg:mt-0"
                              },
                              [
                                _c("div", { staticClass: "flex-shrink-0" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "h-5 w-5 text-green-400",
                                      attrs: {
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          d:
                                            "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                          "clip-rule": "evenodd"
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ml-3 text-sm leading-5 text-gray-700"
                                  },
                                  [
                                    _vm._v(
                                      " $10 for 5000 session messages after 1000 messages "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12"
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-lg leading-6 font-medium text-gray-900"
                          },
                          [_vm._v(" Simple pricing ")]
                        ),
                        _vm._m(1),
                        _c("div", { staticClass: "mt-6" }, [
                          _c("div", { staticClass: "rounded-md shadow" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.choosePlan("advanced")
                                  }
                                }
                              },
                              [_vm._v(" Start 14 day trial ")]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                )
              ]
            )
          ]),
          _c(
            "div",
            {
              staticClass:
                "max-w-screen-xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8"
            },
            [
              _vm._m(2),
              _vm._l(_vm.faqs, function(faq, index) {
                return _c("AccordianItem", {
                  key: index,
                  attrs: { title: faq.title, content: faq.content }
                })
              })
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex items-center" }, [
      _c(
        "h4",
        {
          staticClass:
            "flex-shrink-0 pr-4 bg-white text-sm leading-5 tracking-wider font-semibold uppercase text-indigo-600"
        },
        [_vm._v(" What's included ")]
      ),
      _c("div", { staticClass: "flex-1 border-t-2 border-gray-200" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "mt-4 flex items-center justify-center text-5xl leading-none font-extrabold text-gray-900"
      },
      [
        _c("span", [_vm._v(" $29 ")]),
        _c(
          "span",
          { staticClass: "ml-3 text-xl leading-7 font-medium text-gray-500" },
          [_vm._v(" USD ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "max-w-3xl mx-auto" }, [
      _c(
        "h2",
        {
          staticClass:
            "text-center text-3xl leading-9 font-extrabold text-gray-900 sm:text-4xl sm:leading-10"
        },
        [_vm._v(" Frequently asked questions ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }